/**
 * Tiny JWT helpers — read-only decode, no signature validation. We use this
 * purely to read the `exp` claim from the Supabase access token persisted
 * by `tokenStore` so the UI can warn the user before expiry.
 *
 * NEVER trust the decoded payload for security decisions. The backend
 * re-validates every JWT on every request.
 */

function base64UrlDecode(str) {
  // Convert base64url to base64
  let s = str.replace(/-/g, '+').replace(/_/g, '/');
  // Pad to multiple of 4
  while (s.length % 4) s += '=';
  try {
    return atob(s);
  } catch {
    return null;
  }
}

/**
 * Decode the payload of a JWT. Returns null on any failure.
 */
export function decodeJwt(token) {
  if (!token || typeof token !== 'string') return null;
  const parts = token.split('.');
  if (parts.length !== 3) return null;
  const json = base64UrlDecode(parts[1]);
  if (!json) return null;
  try {
    return JSON.parse(json);
  } catch {
    return null;
  }
}

/**
 * Return the absolute expiry time of a JWT in epoch milliseconds.
 * Returns null when the token is missing/invalid/has no exp claim.
 */
export function getJwtExpiryMs(token) {
  const payload = decodeJwt(token);
  if (!payload || typeof payload.exp !== 'number') return null;
  // `exp` is in seconds since epoch — convert to ms.
  return payload.exp * 1000;
}
